(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!window.customAnnouncementBarScriptLoaded) {
    window.customAnnouncementBarScriptLoaded = true;

    class CustomAnnouncementBar {
      constructor(section) {
        this.section = section;
        this.messages = Array.from(section.querySelectorAll('[data-announcement-index]'));
        this.prevButton = section.querySelector('[data-announcement-prev]');
        this.nextButton = section.querySelector('[data-announcement-next]');
        this.currentIndex = Math.max(
          0,
          this.messages.findIndex((message) => message.classList.contains('is-active'))
        );
        this.intervalMs = Math.max(3000, Number(section.dataset.interval) || 5000);
        this.autoRotate = section.dataset.autorotate === 'true';
        this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.timer = null;

        this.onPrevClick = this.onPrevClick.bind(this);
        this.onNextClick = this.onNextClick.bind(this);
        this.onMouseEnter = this.onMouseEnter.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);
        this.onFocusIn = this.onFocusIn.bind(this);
        this.onFocusOut = this.onFocusOut.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onVisibilityChange = this.onVisibilityChange.bind(this);

        this.init();
      }

      init() {
        if (this.messages.length <= 1) {
          return;
        }

        if (this.prevButton) {
          this.prevButton.addEventListener('click', this.onPrevClick);
        }

        if (this.nextButton) {
          this.nextButton.addEventListener('click', this.onNextClick);
        }

        this.section.addEventListener('mouseenter', this.onMouseEnter);
        this.section.addEventListener('mouseleave', this.onMouseLeave);
        this.section.addEventListener('focusin', this.onFocusIn);
        this.section.addEventListener('focusout', this.onFocusOut);
        this.section.addEventListener('keydown', this.onKeyDown);
        document.addEventListener('visibilitychange', this.onVisibilityChange);

        if (this.autoRotate && !this.prefersReducedMotion) {
          this.start();
        }
      }

      onPrevClick() {
        this.goTo(this.currentIndex - 1, true);
      }

      onNextClick() {
        this.goTo(this.currentIndex + 1, true);
      }

      onMouseEnter() {
        this.stop();
      }

      onMouseLeave() {
        if (this.autoRotate && !this.prefersReducedMotion) {
          this.start();
        }
      }

      onFocusIn() {
        this.stop();
      }

      onFocusOut(event) {
        const relatedTarget = event.relatedTarget;
        if (!this.section.contains(relatedTarget) && this.autoRotate && !this.prefersReducedMotion) {
          this.start();
        }
      }

      onKeyDown(event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.goTo(this.currentIndex - 1, true);
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.goTo(this.currentIndex + 1, true);
        }
      }

      onVisibilityChange() {
        if (document.hidden) {
          this.stop();
          return;
        }

        if (this.autoRotate && !this.prefersReducedMotion) {
          this.start();
        }
      }

      start() {
        this.stop();
        this.timer = window.setInterval(() => {
          this.goTo(this.currentIndex + 1, false);
        }, this.intervalMs);
      }

      stop() {
        if (!this.timer) {
          return;
        }

        window.clearInterval(this.timer);
        this.timer = null;
      }

      goTo(index, userTriggered) {
        if (!this.messages.length) {
          return;
        }

        let nextIndex = index;

        if (nextIndex < 0) {
          nextIndex = this.messages.length - 1;
        }

        if (nextIndex >= this.messages.length) {
          nextIndex = 0;
        }

        if (nextIndex === this.currentIndex) {
          return;
        }

        const currentMessage = this.messages[this.currentIndex];
        const nextMessage = this.messages[nextIndex];

        if (!currentMessage || !nextMessage) {
          return;
        }

        currentMessage.classList.remove('is-active');
        currentMessage.setAttribute('aria-hidden', 'true');

        nextMessage.classList.add('is-active');
        nextMessage.setAttribute('aria-hidden', 'false');

        this.currentIndex = nextIndex;

        if (userTriggered && this.autoRotate && !this.prefersReducedMotion) {
          this.start();
        }
      }

      destroy() {
        this.stop();

        if (this.prevButton) {
          this.prevButton.removeEventListener('click', this.onPrevClick);
        }

        if (this.nextButton) {
          this.nextButton.removeEventListener('click', this.onNextClick);
        }

        this.section.removeEventListener('mouseenter', this.onMouseEnter);
        this.section.removeEventListener('mouseleave', this.onMouseLeave);
        this.section.removeEventListener('focusin', this.onFocusIn);
        this.section.removeEventListener('focusout', this.onFocusOut);
        this.section.removeEventListener('keydown', this.onKeyDown);
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
      }
    }

    const instances = new WeakMap();
    const sectionSelector = '[data-custom-announcement-bar]';

    const findSection = (scope) => {
      if (!(scope instanceof Element) && !(scope instanceof Document)) {
        return null;
      }

      if (scope instanceof Element && scope.matches(sectionSelector)) {
        return scope;
      }

      return scope.querySelector(sectionSelector);
    };

    const initSection = (scope) => {
      const section = findSection(scope);
      if (!section || instances.has(section)) {
        return;
      }

      instances.set(section, new CustomAnnouncementBar(section));
    };

    const destroySection = (scope) => {
      const section = findSection(scope);
      if (!section) {
        return;
      }

      const instance = instances.get(section);
      if (!instance) {
        return;
      }

      instance.destroy();
      instances.delete(section);
    };

    const initAll = () => {
      document.querySelectorAll(sectionSelector).forEach((section) => {
        initSection(section);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initSection(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      destroySection(event.target);
    });

    document.addEventListener('shopify:block:select', (event) => {
      const block = event.target instanceof Element ? event.target.closest('[data-announcement-index]') : null;
      if (!block) {
        return;
      }

      const section = block.closest(sectionSelector);
      if (!section) {
        return;
      }

      const instance = instances.get(section);
      if (!instance) {
        return;
      }

      const nextIndex = Number(block.dataset.announcementIndex);
      if (Number.isNaN(nextIndex)) {
        return;
      }

      instance.goTo(nextIndex, true);
      instance.stop();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-icon-with-text"] && !Shopify.designMode) return;
  try {
    
  if (!window.__customIconWithTextInitialized) {
    window.__customIconWithTextInitialized = true;

    const SECTION_SELECTOR = '.custom-icon-with-text';
    const CARD_SELECTOR = '.custom-icon-with-text__card';
    const TRACK_SELECTOR = '[data-carousel-track]';
    const PREVIOUS_SELECTOR = '[data-carousel-prev]';
    const NEXT_SELECTOR = '[data-carousel-next]';
    const instances = new WeakMap();

    const debounce = (callback, wait = 120) => {
      let timer = null;

      return (...args) => {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => callback(...args), wait);
      };
    };

    const equalizeCardHeights = (section) => {
      const cards = Array.from(section.querySelectorAll(CARD_SELECTOR));
      if (!cards.length) return;

      cards.forEach((card) => {
        card.style.minHeight = '0px';
      });

      let maxHeight = 0;
      cards.forEach((card) => {
        maxHeight = Math.max(maxHeight, card.offsetHeight);
      });

      cards.forEach((card) => {
        card.style.minHeight = `${maxHeight}px`;
      });
    };

    const setupCarouselControls = (section) => {
      const track = section.querySelector(TRACK_SELECTOR);
      const previous = section.querySelector(PREVIOUS_SELECTOR);
      const next = section.querySelector(NEXT_SELECTOR);

      if (!(track instanceof HTMLElement)) return null;
      if (!(previous instanceof HTMLButtonElement) || !(next instanceof HTMLButtonElement)) return null;
      if (!track.classList.contains('custom-icon-with-text__grid--mobile-carousel')) return null;

      const getScrollStep = () => {
        const firstItem = track.querySelector('.custom-icon-with-text__item');
        if (!(firstItem instanceof HTMLElement)) return track.clientWidth;

        const styles = getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return firstItem.getBoundingClientRect().width + gap;
      };

      const updateControlState = () => {
        const maxScrollLeft = Math.max(0, track.scrollWidth - track.clientWidth);
        previous.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= maxScrollLeft - 1 || maxScrollLeft <= 0;
      };

      // iOS Safari fights `scrollBy({ behavior: 'smooth' })` on a container that
      // also has `scroll-snap-stop: always` (used here for touch swiping) - the
      // snap engine re-asserts the current snap position mid-animation, so the
      // button click appears to do nothing (Chrome/Android don't have this bug).
      // Turning snap off for the duration of the programmatic scroll, then back
      // on once it settles, avoids the conflict without affecting finger swipes.
      let reenableSnapTimer = null;

      const scrollByAmount = (amount) => {
        track.style.scrollSnapType = 'none';

        if (reenableSnapTimer) clearTimeout(reenableSnapTimer);
        const reenableSnap = () => {
          track.style.scrollSnapType = '';
          track.removeEventListener('scrollend', reenableSnap);
        };
        track.addEventListener('scrollend', reenableSnap, { once: true });
        // Fallback for browsers without `scrollend` support (e.g. iOS < 17) -
        // longer than the native smooth-scroll animation typically takes.
        reenableSnapTimer = setTimeout(reenableSnap, 500);

        track.scrollBy({ left: amount, behavior: 'smooth' });
      };

      const scrollToPrevious = () => {
        scrollByAmount(getScrollStep() * -1);
      };

      const scrollToNext = () => {
        scrollByAmount(getScrollStep());
      };

      const onScroll = debounce(updateControlState, 40);

      previous.addEventListener('click', scrollToPrevious);
      next.addEventListener('click', scrollToNext);
      track.addEventListener('scroll', onScroll, { passive: true });
      updateControlState();

      return {
        update: updateControlState,
        destroy: () => {
          previous.removeEventListener('click', scrollToPrevious);
          next.removeEventListener('click', scrollToNext);
          track.removeEventListener('scroll', onScroll);
          if (reenableSnapTimer) clearTimeout(reenableSnapTimer);
        },
      };
    };

    const setup = (section) => {
      if (!(section instanceof HTMLElement) || instances.has(section)) return;

      const onResize = debounce(() => equalizeCardHeights(section));
      const carouselControls = setupCarouselControls(section);
      const observer = new ResizeObserver(onResize);
      observer.observe(section);
      window.addEventListener('resize', onResize, { passive: true });
      if (carouselControls) {
        window.addEventListener('resize', carouselControls.update, { passive: true });
      }

      const images = section.querySelectorAll('.custom-icon-with-text__icon-image');
      images.forEach((image) => {
        if (!(image instanceof HTMLImageElement) || image.complete) return;
        image.addEventListener('load', onResize, { once: true });
        image.addEventListener('error', onResize, { once: true });
      });

      requestAnimationFrame(() => {
        equalizeCardHeights(section);
        if (carouselControls) carouselControls.update();
      });
      instances.set(section, { observer, onResize, carouselControls });
    };

    const teardown = (section) => {
      const instance = instances.get(section);
      if (!instance) return;

      instance.observer.disconnect();
      window.removeEventListener('resize', instance.onResize);
      if (instance.carouselControls) {
        window.removeEventListener('resize', instance.carouselControls.update);
        instance.carouselControls.destroy();
      }
      instances.delete(section);
    };

    const setupAll = (root = document) => {
      root.querySelectorAll(SECTION_SELECTOR).forEach((section) => setup(section));
    };

    const teardownAll = (root) => {
      root.querySelectorAll(SECTION_SELECTOR).forEach((section) => teardown(section));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => setupAll());
    } else {
      setupAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLElement)) return;
      setupAll(target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLElement)) return;
      teardownAll(target);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener('DOMContentLoaded', () => {
      const card = document.getElementById(url.hash.slice(1));
      if (card) {
        card.scrollIntoView({behavior: 'instant'});
      }
    }, {once: true});
  }

  } catch(e) { console.error(e); }
})();
})();
